function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Gruppe_3562",
  "data-name": "Gruppe 3562",
  transform: "translate(-591.14 -7484.64)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_750",
  "data-name": "Group 750",
  transform: "translate(604.101 7485.348)"
}, /*#__PURE__*/React.createElement("g", {
  id: "expand-7",
  transform: "translate(0)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Shape_3122",
  "data-name": "Shape 3122",
  d: "M610.208,7499.348l7.031-7-7.031-7",
  transform: "translate(-610.208 -7485.348)",
  fill: "none",
  stroke: "#009fe3",
  strokeWidth: 2
}))), /*#__PURE__*/React.createElement("line", {
  id: "Linie_95",
  "data-name": "Linie 95",
  x1: 19.992,
  transform: "translate(591.14 7492.348)",
  fill: "none",
  stroke: "#009fe3",
  strokeLinejoin: "round",
  strokeWidth: 2
}));

function SvgArrowLightblue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.409,
    height: 15.417,
    viewBox: "0 0 21.409 15.417",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLightblue);
export default __webpack_public_path__ + "static/media/arrow_lightblue.ea917200.svg";
export { ForwardRef as ReactComponent };